import type { StyleRule } from '@archipro-design/aria';

export const ProductTaggingContainer: StyleRule = () => ({
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    height: '100%',
    width: '100%',

    '&:hover': {
        '& .product-tagging-tag': {
            opacity: 1,
            visibility: 'visible',
        },
    },
});
